// extracted by mini-css-extract-plugin
export default {"form":"CheckOut_form__jrNSC","control":"CheckOut_control__MQXcI","actions":"CheckOut_actions__TSmGo","submit":"CheckOut_submit__H2gBJ","invalid":"CheckOut_invalid__F4BSn"};